
import Vue, { PropType } from 'vue';
import { GameEntry, GameMaterials, MaterialFile } from './types';

export default Vue.extend({
  name: 'GameMaterialModal',

  props: {
    game: {
      type: Object as PropType<GameEntry>,
      required: true,
    },
    materials: {
      type: Object as PropType<GameMaterials>,
      required: true,
    },
  },

  computed: {
    safeDemoLink(): string {
      const url = this.localMaterials.demoLink || '';
      return url.startsWith('http://') || url.startsWith('https://') ? url : '#';
    },
  },

  data() {
    return {
      localDemoLink: this.materials.demoLink || '',
      localMaterials: {
        demoLink: this.materials.demoLink,
        gdd: this.materials.gdd ? { ...this.materials.gdd } : null,
        cad: this.materials.cad ? { ...this.materials.cad } : null,
        marketing: this.materials.marketing.map(f => ({ ...f })),
      } as GameMaterials,
      isDraggingGdd: false,
      isDraggingCad: false,
      isDraggingMarketing: false,
    };
  },

  methods: {
    onDropGdd(event: DragEvent) {
      this.isDraggingGdd = false;
      const file = event.dataTransfer?.files[0];
      if (!file) return;
      this.localMaterials.gdd = { name: file.name, type: this.getExtension(file.name) };
    },

    onDropCad(event: DragEvent) {
      this.isDraggingCad = false;
      const file = event.dataTransfer?.files[0];
      if (!file) return;
      this.localMaterials.cad = { name: file.name, type: this.getExtension(file.name) };
    },

    onDropMarketing(event: DragEvent) {
      this.isDraggingMarketing = false;
      if (!event.dataTransfer?.files) return;
      const newFiles: MaterialFile[] = Array.from(event.dataTransfer.files).map(f => ({
        name: f.name,
        type: this.getExtension(f.name),
      }));
      this.localMaterials.marketing = [...this.localMaterials.marketing, ...newFiles];
    },

    onGddFile(event: Event) {
      const input = event.target as HTMLInputElement;
      const file = input.files?.[0];
      if (!file) return;
      this.localMaterials.gdd = { name: file.name, type: this.getExtension(file.name) };
      input.value = '';
    },

    onCadFile(event: Event) {
      const input = event.target as HTMLInputElement;
      const file = input.files?.[0];
      if (!file) return;
      this.localMaterials.cad = { name: file.name, type: this.getExtension(file.name) };
      input.value = '';
    },

    onMarketingFiles(event: Event) {
      const input = event.target as HTMLInputElement;
      if (!input.files) return;
      const newFiles: MaterialFile[] = Array.from(input.files).map(f => ({
        name: f.name,
        type: this.getExtension(f.name),
      }));
      this.localMaterials.marketing = [...this.localMaterials.marketing, ...newFiles];
      input.value = '';
    },

    removeMarketing(index: number) {
      this.localMaterials.marketing.splice(index, 1);
    },

    getExtension(filename: string): string {
      const parts = filename.split('.');
      return parts.length > 1 ? parts[parts.length - 1].toUpperCase() : 'FILE';
    },

    save() {
      if (this.localDemoLink.trim()) {
        this.localMaterials.demoLink = this.localDemoLink.trim();
      }
      this.$emit('save', { ...this.localMaterials });
    },
  },
});
